!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], n) : e.dayjs_locale_de = n(e.dayjs);
}(this, function (e) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e;
  var n = {
    name: "de",
    weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
    months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
    monthsShort: "Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez".split("_"),
    ordinal: function ordinal(e) {
      return e + ".";
    },
    weekStart: 1,
    formats: {
      LTS: "HH:mm:ss",
      LT: "HH:mm",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY HH:mm",
      LLLL: "dddd, D. MMMM YYYY HH:mm"
    },
    relativeTime: {
      future: "in %s",
      past: "vor %s",
      s: "wenigen Sekunden",
      m: "einer Minute",
      mm: "%d Minuten",
      h: "einer Stunde",
      hh: "%d Stunden",
      d: "einem Tag",
      dd: "%d Tagen",
      M: "einem Monat",
      MM: "%d Monaten",
      y: "einem Jahr",
      yy: "%d Jahren"
    }
  };
  return e.locale(n, null, !0), n;
});